/** Runtime config, sourced from Vite env (VITE_*). All values are public. */

const origin = window.location.origin;
const redirectUri = import.meta.env.VITE_OIDC_REDIRECT ?? `${origin}/callback`;

/** The path portion of a redirect URI (prod may register /auth/callback, dev /callback). */
function pathOf(url: string): string {
  try {
    return new URL(url, origin).pathname;
  } catch {
    return '/callback';
  }
}

export const config = {
  oidc: {
    authority: (import.meta.env.VITE_OIDC_ISSUER ?? 'https://auth.prismtx.app').replace(/\/$/, ''),
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? '',
    redirectUri,
    // Detect the callback route from whatever redirect URI is configured, so the
    // app matches the URI registered in Zitadel without hardcoding the path.
    redirectPath: pathOf(redirectUri),
    postLogoutRedirectUri: import.meta.env.VITE_OIDC_POST_LOGOUT ?? `${origin}/`,
    scope: import.meta.env.VITE_OIDC_SCOPE ?? 'openid profile email offline_access',
  },
  // Empty → same-origin (prod behind Caddy, or dev via the Vite /v1 proxy).
  apiBase: (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, ''),
} as const;

/** The API scopes a key can be granted — must match the control-plane's VALID_SCOPES. */
export const VALID_SCOPES = ['swap', 'notify', 'portfolio', 'wallet:read'] as const;
export type Scope = (typeof VALID_SCOPES)[number];

export const SCOPE_HELP: Record<Scope, string> = {
  swap: 'Request and execute swaps within policy caps.',
  notify: 'Send push notifications to the paired phone.',
  portfolio: 'Read balances and portfolio value.',
  'wallet:read': 'Read wallet addresses and metadata.',
};
